/**
 * Depict App
 * -----------------------------------------------------------------------------
 * Logic relating to the Depict App
 *
 */

export default () => {

  /**
   * Initialise component.
   */
  function init() {
    setLocalStorage()
  }

  /**
   * Set localStorage items to be used by the custom checkout pixel
   */
  function setLocalStorage() {
    localStorage.setItem('_dep_merchant', getMerchantId())
    localStorage.setItem('_dep_market', getMarket())
  }

  function getMerchantId() {
    const store = document.body.dataset.store
    const merchant = store === 'toteme-studio' ? 'totemeus' : 'toteme'

    return merchant
  }

  function getMarket() {
    const store = document.body.dataset.store
    let market = document.body.dataset.market

    switch (store) {
      case 'toteme-studio':
        market = 'us'
        break

      case 'toteme-studio-se':
        market = 'se'
        break
    }

    return market
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
